module.exports = __webpack_public_path__ + "static/media/menu_icon_daytraining_normal.13df3eb9.png";